(()=>{
  const init=(scope=document)=>{
    scope.querySelectorAll('[data-mm-gallery],[data-mm-details]').forEach(root=>{
      if(root.dataset.mmReady)return;
      root.dataset.mmReady='true';
      const track=root.querySelector('.mm-gallery-track,[data-mm-track]');
      if(!track)return;
      const count=root.querySelector('[data-mm-count]');
      const update=()=>{if(count)count.textContent=`${Math.min(track.children.length,Math.round(track.scrollLeft/(track.clientWidth+10))+1)} / ${track.children.length}`;};
      root.querySelectorAll('[data-mm-prev],[data-mm-next]').forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:(button.hasAttribute('data-mm-prev')?-1:1)*(track.clientWidth+(root.hasAttribute('data-mm-gallery')?10:0)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
      track.addEventListener('scroll',update,{passive:true});
      track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();track.scrollBy({left:(event.key==='ArrowRight'?1:-1)*track.clientWidth,behavior:'smooth'});}});
      new ResizeObserver(update).observe(track);
      update();
    });
    scope.querySelectorAll('[data-mm-product]').forEach(root=>{
      if(root.dataset.mmReady)return;
      root.dataset.mmReady='true';
      const dialog=root.querySelector('dialog');
      let opener;
      root.querySelectorAll('[data-mm-zoom]').forEach(button=>button.addEventListener('click',()=>{
        const img=button.querySelector('img');const enlarged=dialog.querySelector('img');
        enlarged.src=img.currentSrc||img.src;enlarged.alt=img.alt;opener=button;dialog.showModal();
      }));
      dialog.querySelector('[data-mm-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
      dialog.addEventListener('close',()=>opener?.focus());
      const form=root.querySelector('form');
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        const button=form.querySelector('[type="submit"]');
        if(button.disabled)return;
        const status=form.querySelector('.mm-form-status');const link=form.querySelector('.mm-cart-link');
        button.disabled=true;button.setAttribute('aria-busy','true');status.hidden=true;link.hidden=true;
        try{
          const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
          const data=await response.json();
          if(!response.ok)throw new Error(data.description||data.message||status.dataset.error);
          status.textContent=status.dataset.added;link.hidden=false;
        }catch(error){status.textContent=error.message||status.dataset.error;}
        finally{status.hidden=false;button.disabled=false;button.removeAttribute('aria-busy');}
      });
    });
    scope.querySelectorAll('[data-mm-expand]').forEach(button=>{
      if(button.dataset.mmReady)return;button.dataset.mmReady='true';
      button.addEventListener('click',()=>{const expanded=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(expanded));button.closest('.mm-collection').querySelectorAll('.mm-extra-row').forEach(row=>row.hidden=!expanded);button.textContent=expanded?button.dataset.less+' −':button.dataset.more+' +';});
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
